import React from "react";

import RuleIcon from "@mui/icons-material/Rule";

function RulesIcon({ iconColor, iconSize = "small", ...other }) {
    return <RuleIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default RulesIcon;
